// languageOptions.js — the single shared list of languages the app's report
// language selector (Configure's top toolbar) and every predefined-content
// translation lookup below draw from. Fixed 8-language list per explicit
// request — do not add/remove entries here without also updating every
// *Translations.js file's language keys.
export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English',  native: 'English',   short: 'EN' },
  { code: 'hi', name: 'Hindi',    native: 'हिन्दी',      short: 'HI' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી',    short: 'GU' },
  { code: 'mr', name: 'Marathi',  native: 'मराठी',       short: 'MR' },
  { code: 'bn', name: 'Bengali',  native: 'বাংলা',       short: 'BN' },
  { code: 'kn', name: 'Kannada',  native: 'ಕನ್ನಡ',      short: 'KN' },
  { code: 'ta', name: 'Tamil',    native: 'தமிழ்',       short: 'TA' },
  { code: 'te', name: 'Telugu',   native: 'తెలుగు',      short: 'TE' },
];

// One shared Unicode fallback stack covers all 8 scripts well enough via the
// OS's own font substitution (Nirmala UI on Windows, the system default
// elsewhere) — no extra web font needed just to show a language's own name.
export const LANGUAGE_NATIVE_FONT = "'Noto Sans', 'Nirmala UI', Arial, sans-serif";

// Generic lookup used by every predefined-content builder below: `value` is
// either a plain string (old, not-yet-translated content — returned as-is,
// so nothing breaks while a module is only partly converted) or a
// {en, hi, gu, mr, bn, kn, ta, te} map, in which case this returns the
// requested language, falling back to English, then to whatever's first.
export function pickLang(value, lang) {
  if (value == null) return value;
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map((v) => pickLang(v, lang));
  return value[lang] ?? value.en ?? Object.values(value)[0] ?? '';
}
